import rootRtkQuery from "../rootRTKQuery";

const accountsQueries = rootRtkQuery.injectEndpoints({
  endpoints: (builder) => ({
    getAccountPointOfInterests: builder.query<any, string | null>({
      query: (accountId) => ({
        url: `/accounts/${accountId}/pointsofinterest`,
        headers: {
          "X-Subscription": process.env.REACT_APP_API_HEADER_SUBSCRIPTION,
          "X-TenantId": accountId ?? ""
        }
      }),
      transformResponse: (response: any) => {
        return response;
      }
    })
  }),
  overrideExisting: false
});

export const { useGetAccountPointOfInterestsQuery } = accountsQueries;
